import Vue from 'vue';
// import tpl from './tpl.html';

var CURRENT = null
	, timer1 = null
	, timer2 = null;
var tpl = `<div class="mask mask-transparent center" @click="remove()">
    <div class="notice">
        <i v-show="iconName" class="icon-{{iconName}}"></i>
        <div v-html="text"></div>
    </div>
</div>`;

function Notice(string,iconName,autoCloseTime){
	if(!arguments.length){
		return CURRENT
	}
	document.body.classList.add('overflow-h');
	autoCloseTime=typeof autoCloseTime=='number'?autoCloseTime:2000;
	if( CURRENT ){
		CURRENT.$destroy(true);
		timer1 && clearTimeout( timer1 );
		timer2 && clearTimeout( timer2 );
	}

	CURRENT = new Vue({
		el:document.body.appendChild(document.createElement('div')),
		template:tpl,
		data:{
			iconName:iconName,
			text:string
		},
		methods:{
			remove:function(){
				this.$destroy(true);
				CURRENT = null;
				document.body.classList.remove('overflow-h')
			}
		}
	});
	if(autoCloseTime>0){
		timer1 = setTimeout(function(){
			if( CURRENT ){
				CURRENT.$el.classList.add('an', 'an-out');
			}
			timer1 = null;
		}, autoCloseTime);
		timer2 = setTimeout(function(){
			if( CURRENT ){
				CURRENT.remove();
			}

			CURRENT = null;
			timer2 = null;
		}, autoCloseTime+1000);
	}
}

export default Notice;